import { Fragment, type ReactNode } from 'react';

import Cursor from 'atoms/cursor';

import Career from 'components/career';
import Header from 'components/header';
import Ingress from 'components/ingress';
import Personal from 'components/personal';
import Skills from 'components/skills';

export default function CurriculumVitae(): ReactNode {
	return (
		<Fragment>
			<Cursor />
			<Header />
			<Ingress />
			<Career />
			<Skills />
			<Personal />
		</Fragment>
	);
}
